import { observer } from 'mobx-react-lite'
import { BasicGeneratingScreen } from 'page/BasicInferenceScreen/BasicGeneratingScreen'
import { BasicInferenceScreen } from 'page/BasicInferenceScreen/BasicInferenceScreen'
import { LoadingPage } from 'page/LoadingPage'
import { SelfieProfilePage } from 'page/ProfileScreen/pages/SelfieProfilePage'
import { FullbodyScreen } from 'page/FullbodyScreen/FullbodyScreen'
import { SelfieScreen } from 'page/SelfieScreen/SelfieScreen'
import { store } from 'store/store'
import { BasicNoLimitScreen } from './BasicNoLimitScreen/BasicNoLimitScreen'

export const MaxiBasic = observer(() => {
  if (!store.available) return <BasicNoLimitScreen />
  if (store.basicPending) return <BasicGeneratingScreen />

  switch (store.screen) {
    case 'preload':
      return <LoadingPage />
    case 'selfie':
      return <SelfieScreen />
    case 'fullbody':
      return <FullbodyScreen />
    case 'profile':
      return <SelfieProfilePage />
    case 'generating':
    case 'existing':
    case 'image':
      return <BasicInferenceScreen />
    default:
      console.error('unexpected screen', store.screen)
      return <SelfieProfilePage />
  }

})
